import '.gh{box-sizing:border-box;}.ssr-plugin'
import '.dp{border-radius:1rem;}.ssr-plugin'
import '.gl{padding:2.5rem 1.5rem;}.ssr-plugin'
import '.ay{min-width:0px;}.ssr-plugin'
import '.a0{width:100%;}.ssr-plugin'
import '.gm{height:fit-content;}.ssr-plugin'
import '.gn{align-self:stretch;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ac{align-items:stretch;}.ssr-plugin'
import '.gk{gap:2.5rem;}.ssr-plugin'
import '.g{display:grid;}.ssr-plugin'
import '.v{gap:1rem;}.ssr-plugin'
import '.go{align-items:start;}.ssr-plugin'
import { styled, type Style } from 'inlines'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { Avatar, type AvatarProps } from '@app/components/core/avatar/Avatar'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'

export type ResidentTestimonial = {
  title: string
  quote: string
  name: string
  role: string
  cardStyle?: Style
  avatarVariant: NonNullable<AvatarProps['variant']>
}

export type ResidentTestimonialsSectionProps = {
  isMobile: boolean
  title: string
  intro: string
  testimonials: ReadonlyArray<ResidentTestimonial>
  style?: Style
}

const TestimonialCard = ({
  testimonial,
  style,
}: {
  testimonial: ResidentTestimonial
  style?: Style
}) => {
  const { backgroundImage, ...restCardStyle } = testimonial.cardStyle ?? {}

  return (
    <styled.div className="gh dp gl ay a0 gm gn"
      style={{
        ...restCardStyle,
        ...(backgroundImage
          ? {
              backgroundImage: `url(${backgroundImage})`,
              backgroundPosition: 'bottom right',
              backgroundSize: '40%',
              backgroundRepeat: 'no-repeat',
            }
          : {}),
        ...style,
      }}
    >
      <Column>
        <Title.H4 style={{ marginBottom: 0 }}>{testimonial.title}</Title.H4>
        <Text.Medium>{testimonial.quote}</Text.Medium>
        <Row gap="0.875rem" alignItems="center">
          <Avatar
            size="small"
            shape="circle"
            variant={testimonial.avatarVariant}
            labelSource={testimonial.name}
          />
          <Column gap="0">
            <Title.H5 style={{ marginBottom: 0 }}>{testimonial.name}</Title.H5>
            <Text.Medium>{testimonial.role}</Text.Medium>
          </Column>
        </Row>
      </Column>
    </styled.div>
  )
}

const ResidentTestimonialsSection = ({
  isMobile,
  title,
  intro,
  testimonials,
  style,
}: ResidentTestimonialsSectionProps) => {
  return (
    <styled.div className="a b ac gk a0"
      style={{
        ...style,
      }}
    >
      <Column gap="1rem" style={{ maxWidth: isMobile ? '100%' : '40rem' }}>
        <Title.H2 style={{ marginBottom: 0 }}>{title}</Title.H2>
        <Text.Medium>{intro}</Text.Medium>
      </Column>
      <div className="g v go a0"
        style={{
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, minmax(0, 1fr))',}}
      >
        {isMobile
          ? testimonials.map((item) => (
              <TestimonialCard key={item.title} testimonial={item} />
            ))
          : [0, 1].map((columnIndex) => (
              <Column key={columnIndex} alignItems="stretch">
                {testimonials
                  .filter((_, index) => index % 2 === columnIndex)
                  .map((item) => (
                    <TestimonialCard key={item.title} testimonial={item} />
                  ))}
              </Column>
            ))}
      </div>
    </styled.div>
  )
}

export default ResidentTestimonialsSection
